// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class Procedure_abstract extends BaseObject {
  static $t: string = 'SagaBase.Procedure';
  $t: string = 'SagaBase.Procedure';

  public static GetMembers(): string[] {
    return [
      'ProcedureID',
      'InactivatedProcSteps',
      'ProcStepsReOrder',
      'ProcStepsComplements',
      'Priority',
      'Name',
      'LastGroupRepeat',
      'Info',
      'Steps'
    ];
  }

  public GetMembers(): string[] {
    return Procedure_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ProcedureID: number;
  public InactivatedProcSteps: Guid[];
  public ProcStepsReOrder: Guid[];
  public ProcStepsComplements: string;
  public Priority: number;
  public Name: string;
  public LastGroupRepeat: boolean = false;
  public Info: string;
  public Steps: any[];

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
